import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  ConfigureTemplates,
  GradingPeriods,
  PrepareData,
  GenerateTranscripts,
} from "./routes";

export default store => ({
  path: "transcripts-v2",
  component: withAsyncRouteLoading(() =>
    import(/* webpackChunkName: "transcripts-v2" */ "./components").then(
      m => m.default
    )
  ),
  childRoutes: [
    GradingPeriods(store),
    PrepareData(store),
    ConfigureTemplates(store),
    GenerateTranscripts(store),
  ],
});
